/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DetailsRequestBuilderNavigationMetadata, DetailsRequestBuilderRequestsMetadata, type DetailsRequestBuilder } from './details/index.js';
// @ts-ignore
import { LookupRequestBuilderNavigationMetadata, LookupRequestBuilderRequestsMetadata, type LookupRequestBuilder } from './lookup/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/addresses
 */
export interface AddressesRequestBuilder extends BaseRequestBuilder<AddressesRequestBuilder> {
    /**
     * The details property
     */
    get details(): DetailsRequestBuilder;
    /**
     * The lookup property
     */
    get lookup(): LookupRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AddressesRequestBuilderUriTemplate = "{+baseurl}/api/addresses";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AddressesRequestBuilderNavigationMetadata: Record<Exclude<keyof AddressesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    details: {
        requestsMetadata: DetailsRequestBuilderRequestsMetadata,
        navigationMetadata: DetailsRequestBuilderNavigationMetadata,
    },
    lookup: {
        requestsMetadata: LookupRequestBuilderRequestsMetadata,
        navigationMetadata: LookupRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
